import React from 'react';
import { Box, Button, Dialog, Typography } from 'src/components';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface AiPromptDetailsModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  criteria: string;
  actionPlan: any;
}

const AiPromptDetailsModal = ({
  open,
  onClose,
  title,
  criteria,
  actionPlan,
}: AiPromptDetailsModalProps) => {
  // Format the action plan as prettified JSON if it's an object or array
  const formattedActionPlan =
    typeof actionPlan === 'string'
      ? actionPlan
      : JSON.stringify(actionPlan, null, 2);

  return (
    <Dialog className="max-w-6xl h-160" isOpen={open} onClose={onClose}>
      <Dialog.Header className="!py-2">
        <Box className="flex items-center justify-between">
          <Box className="flex flex-col gap-1">
            <Typography className="text-base font-bold text-primary">
              AI Prompt Details
            </Typography>
            <Typography className="text-sm font-medium text-tertiary">
              {title}
            </Typography>
          </Box>
          <Button size="sm" variant="plain" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </Box>
      </Dialog.Header>
      <Dialog.Content>
        <Box className="flex flex-col gap-4 p-4">
          <Box className="flex flex-col gap-1">
            <Typography className="text-sm font-semibold text-primary">
              Criteria
            </Typography>
            <Typography className="text-sm">{criteria}</Typography>
          </Box>
          <Box className="flex flex-col gap-1">
            <Typography className="text-sm font-semibold text-primary">
              Action Plan
            </Typography>
            <pre className="text-xs bg-gray-100 border border-gray-400 p-3 rounded-md overflow-auto h-full">
              {formattedActionPlan}
            </pre>
          </Box>
        </Box>
      </Dialog.Content>
    </Dialog>
  );
};

export default AiPromptDetailsModal;
